import { useEffect } from 'react';
import {
	useCommandPaletteAnalyticsAttributes,
	useCommandPaletteIsOpen,
} from '@atlassian/jira-command-palette/src/controllers/command-palette/index.tsx';
import { usePrevious } from '@atlassian/jira-platform-react-hooks-use-previous/src/common/utils/index.tsx';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import {
	useQuickSearchAnalytics,
	useQuickSearchAnalyticsAttributes,
} from '../../../controllers/use-quick-search-analytics';

export const useFireQuickSearchAnalyticsOnClose = () => {
	const [{ isOpen }] = useCommandPaletteIsOpen();
	const previousIsOpen = usePrevious(isOpen);
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [{ hasModalWrapperMounted }] = useQuickSearchAnalytics();

	// Need to get the previousAttributes since they will change after closing compal
	const [attributes] = useCommandPaletteAnalyticsAttributes();
	const previousAttributes = usePrevious(attributes);

	const [compalAttributes] = useQuickSearchAnalyticsAttributes();
	const previousCompalAttributes = usePrevious(compalAttributes);

	useEffect(() => {
		if (hasModalWrapperMounted && previousIsOpen && !isOpen) {
			fireUIAnalytics(createAnalyticsEvent({}), 'close commandPaletteSearch', {
				...previousCompalAttributes,
				...previousAttributes,
			});
		}
	}, [
		createAnalyticsEvent,
		isOpen,
		previousIsOpen,
		hasModalWrapperMounted,
		previousCompalAttributes,
		previousAttributes,
	]);
};
